import type { ActionReturn } from 'svelte/action';

const nodes: Set<HTMLElement> = new Set();

function dispatchClickOutside(event: Event, notElements?: HTMLElement) {
	nodes.forEach((node) => {
		if (node !== event.target && !node.contains(event.target as HTMLElement) && !notElements?.contains(event.target as HTMLElement)) {
			node.dispatchEvent(new CustomEvent('ClickOutside', { detail: event, cancelable: true, bubbles: true }));
		}
	});
}

function enable(node: HTMLElement, notElements?: HTMLElement) {
	if (nodes.size === 0) {
		document.addEventListener('click', event => dispatchClickOutside(event, notElements), true);
	}
	nodes.add(node);
}

function disable(node: HTMLElement, notElements?: HTMLElement) {
	nodes.delete(node);
	if (nodes.size === 0) {
		document.removeEventListener('click', event => dispatchClickOutside(event, notElements), true);
	}
}

export function clickOutside(node: HTMLElement, { disabled = false, notElements }: { disabled?: boolean; notElements?: HTMLElement }): ActionReturn<{ disabled?: boolean }, { onClickOutside: (event: CustomEvent) => void }> {
	if (!disabled) {
		enable(node, notElements);
	}
	return {
		update({ disabled }) {
			disabled ? disable(node, notElements) : enable(node, notElements);
		},
		destroy() {
			disable(node, notElements);
		},
	};
}
